import React, { FC, useCallback, useState } from "react";
import { ICalendarUrl, setClass } from "@utils";
import { isMobile } from 'react-device-detect';
import { CalendarTitle } from "./CalendarTitle";
import { CalendarUrl } from "./CalendarUrl";
import { IColor } from "../../utils/types/colors";
import { Button } from "../button";
import '../../styles/components/connectedCalendarField.scss';

interface ConnectedCalendarFieldProps {
  calendar : ICalendarUrl;
  colors: IColor[];
  isChanging?: boolean;
  onDeleteCalendar: (id: number) => void;
  onChange: (calendar: ICalendarUrl) => void;
  getColor: (name: string) => IColor;
  onChangeClick: (id: number) => void;
  onChangeApply: () => void;
}

export const ConnectedCalendarField : FC<ConnectedCalendarFieldProps> = ({ 
  colors, calendar, onDeleteCalendar, isChanging: changing, getColor, 
  onChangeClick, onChange, onChangeApply 
}) => {
  const onDelete = useCallback(() => onDeleteCalendar(calendar.id), [calendar]);
  const resetEditCalendar = useCallback(() => onChangeClick(null), []);
  const [error, setError] = useState(false);
  const onSave = () => {
    if (calendar.title.trim().length === 0) {
      setError(true);
    } else {
      setError(false);
      onChangeApply();
    }
  }

  return (
    <div className={setClass('calendar-area', isMobile && 'mobile')}>
      <CalendarTitle 
        error={error} 
        setErr={setError}
        getColor={getColor}
        colors={colors}
        calendar={calendar}
        changing={changing}
        onChangeClick={onChangeClick} 
        onChange={onChange}
      />
      <CalendarUrl 
        calendar={calendar} 
        onDeleteCalendar={onDelete} 
        error={false} 
      />
      {
        changing && (
          <div className="apply-cancel-buttons-area">
            <Button title="Отмена" onClick={resetEditCalendar} className="outlined small"/>
            <Button title="Сохранить" onClick={onSave} className="small"/>
          </div>
        )
      }
    </div>
  );
};
